var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
    'img-block',
    _vm.isEditMode && 'border',
    !_vm.selected ? 'selectionMode__not-selected' : 'selectionMode__selected'
  ]},[_c('img',{staticClass:"img-thumbnail",class:[!_vm.isEditMode && 'img-thumbnail__effect'],attrs:{"alt":"thumbnail","crossorigin":"anonymous","src":_vm.url},on:{"click":function($event){return _vm.toggleFullscreen(_vm.image, _vm.index)}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }